<template>
<modal name="capla-dialog"
  id="capla-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div >
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeDialog"
        icon="el-icon-circle-close-outline"
        style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting" v-if="permissionType == 1">
      <div class="setting-item" style="text-align: center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>

        <p style="display: inline-block; margin: 10px;">
            <img src="/static/renew2_img/capla_kango_yagish.png" alt="キャプラ看護ナビとヤギッシュ">
        </p>

        <p style="font-weight: bold;">ご同意いただいた方には追って連絡がいきますので<br>ご確認お願いいたします！</p>


        <p style="font-size: 0.8rem; padding: 5px;">
                Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link><br/>

                キャプラ看護ナビ 人材紹介サービスの<a href="https://www.nc-call.jp/other/privacy.html" target="_blank">利用規約</a>、<a href="https://www.nc-call.jp/other/privacy.html" target="_blank">個人情報保護方針</a>を
                <br>確認してキャプラ看護ナビに登録することになります。
        </p>

        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;"> 
            <img src="/static/renew_img/check_icon.png" style="width:40px" >規約に同意して無料相談を希望する
          </p>
        </div>

        <div class="text-center">
          <el-button :id="'pdf-'+$globalVar.dn_flag+'-rt-completed'" type="success" v-if="isSended == false" style="background-color:#E3165C;border-color:#E3165C;font-size: 140%;"
            @click="$eventHub.$emit('send-capla-consult');">　同意する　</el-button>
          <el-button :id="'pdf-'+$globalVar.dn_flag+'-rt-completed-done'" type="success" v-if="isSended == true"
            @click="closeDialog();">送信しました</el-button>
        </div>
      </div>
    </div>
    <div class="setting" v-if="permissionType == 2">
      <div class="setting-item" style="text-align: center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>

        <p style="display: inline-block; margin: 10px;">
            <img src="/static/renew2_img/capla_kaigo_yagish.png" alt="キャプラ看護ナビとヤギッシュ">
        </p>

        <p style="font-weight: bold;">ご同意いただいた方には追って連絡がいきますので<br>ご確認お願いいたします！</p>


        <p style="font-size: 0.8rem; padding: 5px;">
                Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link><br/>

                キャプラ介護ナビ 人材紹介サービスの<a href="https://capla-kaigo.jp/c/terms/" target="_blank">利用規約</a>、<a href="https://capla-kaigo.jp/c/terms/" target="_blank">個人情報保護方針</a>を
                <br>確認してキャプラ介護ナビに登録することになります。
        </p>

        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;"> 
            <img src="/static/renew_img/check_icon.png" style="width:40px" >規約に同意して無料相談を希望する
          </p>
        </div>

        <div class="text-center">
          <el-button :id="'pdf-'+$globalVar.dn_flag+'-rt-completed'" type="success" v-if="isSended == false" style="background-color:#E3165C;border-color:#E3165C;font-size: 140%;"
            @click="$eventHub.$emit('send-capla-consult');">　同意する　</el-button>
          <el-button :id="'pdf-'+$globalVar.dn_flag+'-rt-completed-done'" type="success" v-if="isSended == true"
            @click="closeDialog();">送信しました</el-button>
        </div>
      </div>
    </div>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>

<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      gradeYear: 0,
      permissionType: 1,
      isSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:true,
      inputEmail:'',
      gradeYear:'',
      foreignStudent:false,
      isRandom:true
    }
  },
  created : function(){
    console.error('newgrade created')
    const app = this
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openCaplaDialog: function (id, html, permissionType) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('capla-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.permissionType = permissionType
      const app = this

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'capla_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })
    },
    closeDialog: function () {
      this.$modal.hide('capla-dialog')
      this.clearLocalStorageConfirmVisible = false
      //this.$router.push('/mypage')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendCaplaConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const app = this
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'capla_dialog')
      formData.append('permission_type', this.permissionType)
      
      if ((!this.$firebase.user.email && this.inputEmail) || 
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && this.inputEmail)) {
        formData.append('inputemail', this.inputEmail)
      }
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '3')
      formData.append('reqflg', '2')
      this.$axios
        .post(this.$varuna.endPoints.sendCapla, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスに連絡が届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 0,
            showClose: true,
            message: '応募に失敗しました。入力内容を確認して再度ご応募ください',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-capla-consult', this.sendCaplaConsult)
    this.$eventHub.$on('open-capla-dialog', this.openCaplaDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-capla-consult', this.sendCaplaConsult)
    this.$eventHub.$off('open-capla-dialog', this.openCaplaDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
